import { useTranslation } from 'react-i18next';
import { Button, Flex, Modal } from 'antd';
import { ReactNode } from 'react';
import { ButtonColorType } from 'antd/es/button';

import './confirmModal.scss';
import Icon from 'utils/icon';

interface ConfirmModalProps {
	open: boolean;
	title: string;
	subTitle?: string;
	confirmText: string;
	confirmColor?: ButtonColorType;
	onDiscard: any;
	discardText?: string; // for DefaultFooter
	onConfirm: any;
	description?: string;
	note?: ReactNode;
	noteType?: 'red' | 'blue';
	isLoading?: boolean;
	confirmDisabled?: boolean;
	children?: ReactNode;
	large?: boolean;
	descriptionClasses?: string;
}

function DefaultFooter({ onDiscard, discardText, onConfirm, confirmText, confirmColor, isLoading, confirmDisabled }: Partial<ConfirmModalProps>) {
	return [
		<Button key="discard" onClick={onDiscard} type="link" danger size="middle">
			{discardText}
		</Button>,
		<Button key="confirm" onClick={onConfirm} variant="solid" color={confirmColor} size="middle" loading={isLoading} disabled={confirmDisabled}>
			{confirmText}
		</Button>,
	];
}

function ConfirmModalComponent({
	open,
	title,
	subTitle,
	confirmText,
	confirmColor = 'primary',
	onDiscard,
	onConfirm,
	description,
	note,
	noteType = 'blue',
	isLoading,
	confirmDisabled,
	children,
	large,
	descriptionClasses
}: ConfirmModalProps) {
	const { t } = useTranslation();

	return (
		<Modal
			open={open}
			title={
				<Flex gap={10} align="center">
					<Icon name="info" width={subTitle ? 40 : 30} height={subTitle ? 40 : 30} />
					<div>
						<h6 className="mb-0">{title}</h6>
						<span className="text-light" style={{ fontSize: 14 }}>
							{subTitle}
						</span>
					</div>
				</Flex>
			}
			className={`confirmationModal ${large ? 'large' : ''} `}
			bodyProps={{ style: { padding: description ? '15px 20px' : '0px 20px' } }}
			onCancel={onDiscard}
			footer={DefaultFooter({ onDiscard, onConfirm, confirmText, confirmColor, isLoading, confirmDisabled, discardText: t('COMMON.CANCEL') })}>
			{description && <p className={`mb-0 ${descriptionClasses}`}>{description}</p>}

			{note && (
				<div className={`highlight ${noteType}`}>
					<h6 className="fw-medium mb-1">{t('COMMON.NOTE')}</h6>
					{note}
				</div>
			)}

			{children}
		</Modal>
	);
}

export default ConfirmModalComponent;
